module.exports = __webpack_public_path__ + "img/grillagee-full.7c7e9f9.svg";